import { gql } from '__generated__';

export default gql(`
  mutation ExportOrders($input: ExportOrdersInput!) {
    exportOrders(input: $input) {
      id
    }
  }
`);
